import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import LcvParticipantImport from "./views/LcvParticipantImport";
import LcvParticipantImportResults from "./views/LcvParticipantImportResults";

import { lcvParticipantsClearImportResult } from "../../../../_redux/_actions/lcvParticipants.action";

// The LCV participant list is loaded here. The spreadsheet is read in the browser and only the
// parsed rows are ever sent.
export default function LcvParticipantUploadWrapper() {
     const actionDispatch = useDispatch();

     const importResult = useSelector((state) => state?.lcvParticipants?.importResult);

     useEffect(() => {
          return () => {
               actionDispatch(lcvParticipantsClearImportResult());
          };
     }, [actionDispatch]);

     const done = useCallback(() => {
          actionDispatch(lcvParticipantsClearImportResult());
     }, [actionDispatch]);

     return (
          <>
               <MainLeftTitle title="LCV Participant Upload" />

               <div className="sba-telerik-components-wr">
                    {/* Either the file being prepared or the outcome is on screen, never both. */}
                    {importResult ? (
                         <LcvParticipantImportResults result={importResult} onDone={done} />
                    ) : (
                         <LcvParticipantImport />
                    )}
               </div>
          </>
     );
}
